// Globals
import { useTranslation } from 'react-i18next';

// Components
import { showSuccessToast } from '@/components';
import { GeneralSettingsForm } from '../../components';

// Store
import { useAppDispatch } from '@/store';
import { updateGeneralSettings } from '../../feature';

// Helpers
import { TGeneralSettingsValues } from '../../helpers';
import { useGetGeneralSettings } from '../../hooks';

const GeneralSettingsContainer = () => {
  const { t } = useTranslation('settings');

  const dispatch = useAppDispatch();
  const { generalSettings, isLoading } = useGetGeneralSettings();

  const handleSubmit = async (values: Partial<TGeneralSettingsValues>) => {
    if (!generalSettings) return;
    try {
      await dispatch(updateGeneralSettings({ ...generalSettings, ...values })).unwrap();
      showSuccessToast({ message: t('success_message') });
    } catch (error) {
      console.error(error);
    }
  };

  return <GeneralSettingsForm onSubmit={handleSubmit} isLoading={isLoading} initialValues={generalSettings ?? {}} />;
};

export default GeneralSettingsContainer;
